import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";
import { getLatestDate, getOldestDate, getListBookings } from "../api/booking";
import { CHECKING_STATUS } from "../lib/constant";
const booking = {
  state: {
    listBookings: [],
    listBrands: [],
    selectedBranch: "", // is string
    statistics: [],
    oldestDate: new Date(),
    lastestDate: new Date(),
    total: 0,
    count: 0,
    totalBookingChecking: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    changeSelectedBranch(state, payload) {
      state.selectedBranch = payload;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getLatestDate(
      payload = { query: {}, sort: "-createdAt" },
      rootState
    ) {
      const response = await getLatestDate({
        query: payload.query,
        sort: payload.sort,
      });
      if (response.code !== 1) {
        return;
      }
      this.setState({ lastestDate: response.data });
    },
    async getOldestDate(payload = { query: {}, sort: "createdAt" }, rootState) {
      const response = await getOldestDate({
        query: payload.query,
        sort: payload.sort,
      });
      if (response.code !== 1) {
        return;
      }
      this.setState({ oldestDate: response.data });
    },
    async getListBookings(payload = {}, rootState) {
      let page = 1;
      let pageSize = 10;
      if (payload.page) {
        page = payload.page + 1;
      }
      if (payload.limit) {
        pageSize = payload.limit;
      }
      delete payload.limit;
      const response = await getListBookings({ ...payload, page, pageSize });
      if (response.code === 1) {
        this.setState({
          listBookings: response.data.list,
          total: response.data.total,
          count: response.data.count,
        });
      }
      return response;
    },
    async deleteBooking(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/bookings/deleteBooking";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },

    async editBookingForSpa(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/bookings/editBookingForSpa";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          spaNote: payload.spaNote,
          bookingCode: payload.bookingCode,
          status: payload.status,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getListBranchs(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/serviceBranches/getListBranch",
        {
          method: "POST",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({ listBrands: result.data });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async createBooking(payload, rootState) {
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(DomainAPI + Channel + "/api/secure/bookings/create", {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async statisticsBooking(payload = {}, rootState) {
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(
        DomainAPI + Channel + "/api/secure/bookings/statisticsBooking",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) this.setState({ statistics: result.data });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async totalBookingChecking(payload = {}, rootState) {
      const response = await getListBookings({
        query: { ...payload, status: CHECKING_STATUS },
      });
      if (response.code === 1) {
        this.setState({
          totalBookingChecking: response.data.total,
        });
      }
    },
  }),
};

export default booking;
